import { programConfig, TokenConfig } from "./program_config";

export const maxxpainnToken: TokenConfig = programConfig.token;

export const tokenConfig = maxxpainnToken;
